import {initElements} from "../define/shared";

export default function initContactBlock() {
    initElements(".contact.wa-block", block => {
        const wpcf7 = block.querySelector(".wpcf7"),
            content = block.querySelector(".content"),
            showForm = block.querySelector("[data-action=\"show-form\"]");

        wpcf7.addEventListener("wpcf7mailsent", () => {
            content.classList.add("is--sent")
        });

        showForm.addEventListener("click", () => {
            content.classList.remove("is--sent")
        });
    });
}
